import { render } from "./SparklineField.vue?vue&type=template&id=a6cb2d52"
import script from "./SparklineField.vue?vue&type=script&lang=js"
export * from "./SparklineField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SparklineField.vue"]])

export default __exports__